import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsCustomFieldsRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-custom-fields-view',
	path: '/secure/admin/ViewCustomFields(!default)?.jspa',
};
